import React from 'react';
import StaticPageLayout from '../components/StaticPageLayout';

const CopyrightPage = () => (
  <StaticPageLayout
    overline="Publication Ethics"
    title="Copyright & Licensing"
    description="This page outlines the copyright policy governing published works on the MAH Quantum Research Institute platform, including author rights and permitted reuse."
    breadcrumbs={[{ label: 'Publication Ethics', path: '/publication-ethics' }, { label: 'Copyright & Licensing', path: '/copyright' }]}
  >
    <div className="space-y-10">
      <section>
        <h2 className="font-serif text-2xl font-semibold text-[#1F1F1F] mb-4 pb-3 border-b border-[#E5E7EB]">Copyright Ownership</h2>
        <p className="text-[#4B5563] leading-relaxed mb-4">
          Authors of manuscripts published in MAH Quantum Research Institute journals retain copyright of their work. Publication on the platform is granted through a <strong>non-exclusive publishing licence</strong>, allowing the institute to publish, distribute, and archive the work in its original and derived formats.
        </p>
        <p className="text-[#4B5563] leading-relaxed">
          Authors are free to share, distribute, and reuse their own work, including uploading to institutional repositories, personal academic profiles, and preprint servers, provided the published source is properly attributed.
        </p>
      </section>

      <section>
        <h2 className="font-serif text-2xl font-semibold text-[#1F1F1F] mb-5 pb-3 border-b border-[#E5E7EB]">Licensing Terms</h2>
        <div className="border border-[#E5E7EB] p-6 bg-[#F5F7FA]">
          <p className="font-semibold text-[#1F1F1F] text-sm mb-2">Creative Commons Attribution (CC BY 4.0)</p>
          <p className="text-sm text-[#4B5563] leading-relaxed mb-3">
            Unless otherwise stated, published articles are made available under the Creative Commons Attribution 4.0 International Licence (CC BY 4.0). Under this licence, readers and researchers may:
          </p>
          <ul className="space-y-1.5 text-sm text-[#4B5563]">
            {['Share — copy and redistribute the material in any medium or format', 'Adapt — remix, transform, and build upon the material for any purpose, including commercially'].map(item => (
              <li key={item} className="flex items-start gap-2">
                <span className="w-1.5 h-1.5 bg-[#1A73E8] rounded-full flex-shrink-0 mt-1.5" />{item}
              </li>
            ))}
          </ul>
          <p className="text-sm text-[#6B7280] mt-3 italic">Provided that appropriate credit is given, a link to the licence is provided, and any changes made are indicated.</p>
        </div>
      </section>

      <section>
        <h2 className="font-serif text-2xl font-semibold text-[#1F1F1F] mb-4 pb-3 border-b border-[#E5E7EB]">Reuse of Third-Party Material</h2>
        <p className="text-[#4B5563] leading-relaxed mb-3">
          Authors who include figures, tables, or text excerpts from third-party sources in their manuscript are responsible for obtaining the necessary reproduction permissions prior to submission. Evidence of permission must be included in the submission where required.
        </p>
        <p className="text-[#4B5563] leading-relaxed">
          For enquiries regarding copyright, permissions, or licensing, please contact: <span className="text-[#1A73E8]">submissions@mahquantum.tech</span>
        </p>
      </section>
    </div>
  </StaticPageLayout>
);

export default CopyrightPage;
